import * as React from 'react';
import * as style from './HeaderLayout.css';

export interface IHeaderLayoutProps {
  backButton: React.ReactNode;
  chips: React.ReactNode;
  counter: React.ReactNode;
  fakeSearchInput: React.ReactNode;
  sorting: React.ReactNode;
  titleAndDescription: React.ReactNode;
}

export const HeaderLayout: React.FC<IHeaderLayoutProps> = props => {
  const { backButton, chips, counter, fakeSearchInput, sorting, titleAndDescription } = props;

  return (
    <div className={style['container']}>
      <div className={style['back_button']}>{backButton}</div>
      <div className={style['title_and_description']}>{titleAndDescription}</div>
      <div className={style['sorting']}>{sorting}</div>
      <div className={style['fake_search_input']}>{fakeSearchInput}</div>
      <div className={style['chips']}>{chips}</div>
      <div className={style['counter']}>{counter}</div>
    </div>
  );
};
